// ** Logo
import React from 'react';
import logo from '@src/assets/images/logo/logo_icon_purple.png';

const SpinnerComponent = () => {
	return (
		<div className="fallback-spinner vh-100">
			<img
				className="fallback-logo"
				src={logo}
				alt="logo"
				width={30}
				style={{
					transform: 'translate(60%, 0)',
				}}
			/>
			<div className="loading">
				<div className="effect-1 effects"></div>
				<div className="effect-2 effects"></div>
				<div className="effect-3 effects"></div>
			</div>
		</div>
	);
};

export default SpinnerComponent;
